import { Link, Stack, Tooltip, Typography } from "@mui/material";

import config from "config";

export const Footer = () => {
  return (
    <Stack
      component="footer"
      direction="row"
      marginTop="auto"
      alignItems="center"
      justifyContent="space-between"
      sx={{
        color: "white",
        zIndex: 1,
        bgcolor: "primary.main",
        boxShadow: "0px -10px 10px -5px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Tooltip title={config.env}>
        <Typography variant="body2" align="center" p={1}>
          {config.version}
        </Typography>
      </Tooltip>

      <Typography variant="body2" align="center" p={1}>
        <Link color="inherit" href="https://www.ghsiss.com/">
          INTEGRITY Security Services, LLC.
        </Link>{" "}
      </Typography>

      <Typography variant="body2" align="center" p={1}>
        {" © "}
        {new Date().getFullYear()}
      </Typography>
    </Stack>
  );
};
